import { useEffect } from "react";
import "./styles.less";
import { RightOutlined } from "@ant-design/icons";
import { Typography } from "antd";

export const BannerHeader = ({ data }) => {
	const showBanner = () => {
		document.body.classList.add("body-banner-header");
	};

	const hideBanner = () => {
		document.body.classList.remove("body-banner-header");
	};

	useEffect(() => {
		showBanner();
		return () => hideBanner();
	}, []);

	return (
		<>
			<a
				id="banner-header"
				href={data.link}
				target="_blank"
				style={{
					backgroundColor: data.html ? "#fff" : data.background_color,
					color: data.text_color,
				}}>
				{data.html ? (
					<iframe src={data.html} /> // 70px x 100% desktop y 92px x 100% mobile
				) : (
					<div className="contenedor">
						{/* 700 x 70 */}
						<img src={data.image} className="banner" />
						<div
							className="right-content"
							style={{
								backgroundColor: data.background_color,
								color: data.text_color,
							}}>
							<div className="texto">
								<Typography.Text
									ellipsis
									className="top"
									style={{ color: data.text_color }}>
									{data.title}
								</Typography.Text>
								{/* 50 chars */}
								<Typography.Paragraph
									className="bottom"
									ellipsis={{ rows: 2 }}
									style={{ color: data.text_color }}>
									{data.text}
								</Typography.Paragraph>
							</div>
							<div
								className="btn desktop"
								style={{
									backgroundColor: data.button_background_color,
									color: data.button_text_color,
								}}>
								{data.button_text}
							</div>
							<div
								className="btn mobile"
								style={{
									backgroundColor: data.button_background_color,
									color: data.button_text_color,
								}}>
								<RightOutlined color={data.button_text_color} />
							</div>
						</div>
					</div>
				)}
			</a>
			<style jsx>{`
				#banner-header:hover .btn {
					background-color: ${data.button_text_color} !important;
					color: ${data.button_background_color} !important;
				}
			`}</style>
		</>
	);
};

